import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProfileComponent} from './profile/profile.component';
import {ProfileDashboardComponent} from './profile-dashboard/profile-dashboard.component';
import {ProfileOrderComponent} from './profile-order/profile-order.component';
import {ProfileAccountComponent} from './profile-account/profile-account.component';
import {ProfileAddressComponent} from './profile-address/profile-address.component';
import {RequestMapperService} from '../request-mapper.service';
import {ProfileOrderListingComponent} from './profile-order-listing/profile-order-listing.component';
import {OrderThankYouComponent} from "./order-thank-you/order-thank-you.component";
import {ProfileCustomOrderComponent} from "./profile-custom-order/profile-custom-order.component";

const routes: Routes = [
	{
		path:'',
		component:ProfileComponent,
		children:[

			{
				path: "",
				redirectTo:RequestMapperService.PROFILE_DASHBOARD,
				pathMatch:'full'
			},
			{
				path: RequestMapperService.PROFILE_DASHBOARD,
				component:ProfileDashboardComponent,
			},
			{
				path: RequestMapperService.PROFILE_ADDRESS,
				component:ProfileAddressComponent,
			},
			{
				path: RequestMapperService.PROFILE_ORDER,
				component:ProfileOrderListingComponent,
			},
			{
				path: RequestMapperService.PROFILE_ORDER+'/:id',
				component:ProfileOrderComponent,
			},
			{
				path: RequestMapperService.PROFILE_ORDER_CUSTOM+'/:id',
				component: ProfileCustomOrderComponent,
			},
			{
				path: RequestMapperService.THANK_YOU_URL+'/:id',
				component:OrderThankYouComponent,
			},
			{
				path: RequestMapperService.PROFILEACCOUNT,
				component:ProfileAccountComponent,
			}
		]
	},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
